<template>
  <div class="content blacklist">
    <el-form
      ref="formformData"
      :model="formData"
      label-width="160px"
      size="mini"
    >
      <div class="box">
        <div class="title">优惠规则</div>
        <el-form-item label="适用卡项">
          <el-radio-group
            v-if="card_type == '0'"
            v-model="card_type"
            :disabled="$route.query.eid !== undefined"
          >
            <el-radio :label="0">会员卡</el-radio>
            <el-radio :label="1">加油卡</el-radio>
            <el-radio :label="3">车队卡</el-radio>
          </el-radio-group>
          <el-radio-group
            v-else-if="card_type == '3'"
            v-model="card_type"
            :disabled="$route.query.eid !== undefined"
          >
            <el-radio :label="0">会员卡</el-radio>
            <el-radio :label="1">加油卡</el-radio>
            <el-radio :label="3">车队卡</el-radio>
          </el-radio-group>
          <el-radio-group v-else v-model="card_type">
            <el-radio :label="0">会员卡</el-radio>
            <el-radio :label="1">加油卡</el-radio>
            <el-radio :label="3">车队卡</el-radio>
          </el-radio-group>
          <div class="selection_box" v-if="card_type == '0'">
            <el-checkbox-group v-model="selectLevel">
              <el-checkbox
                v-for="item in vipLevelList"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="selection_box" v-if="card_type == '1'">
            <el-checkbox-group v-model="selectOilsCard">
              <el-checkbox
                v-for="item in oilsCardList"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="selection_box" v-if="card_type == '3'">
            <el-checkbox-group
              v-model="selectCardList"
              :disabled="$route.query.eid !== undefined"
            >
              <el-checkbox
                v-for="item in cardListCard"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <!-- <el-form-item label="规则设置"></el-form-item> -->

        <div class="rule_box">
          <el-collapse v-model="activeName" accordion style="width: 85%">
            <el-collapse-item title="固定充值" name="1">
              <div
                class="dialogflex"
                v-for="(item, index) in setlist"
                :key="index"
              >
                <div class="flex_left">
                  <!-- <div class="flex_title">赠送条件</div> -->
                  <div>
                    <span style="margin-right:30px;">第{{ index + 1 }}档</span>
                    <div class="line_title">充值</div>
                    <el-input
                      size="small"
                      class="input_box_short"
                      v-model="item.amount"
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </div>
                </div>
                <div class="flex_right">
                  <el-checkbox-group v-model="item.give">
                    <div class="check_block">
                      <el-checkbox
                        label="balance"
                        style="margin-right: 10px;"
                        @change="checkClick($event, item, 'balance')"
                      >
                        送余额
                      </el-checkbox>
                      <el-input
                        v-model="item.balance"
                        size="mini"
                        class="input_box_mini"
                        @focus="inputFocus(index, 'balance')"
                        ><template slot="append">元</template></el-input
                      >
                      <span style="margin-left:100px">
                        <el-button type="text" @click="delSetItem(index, '1')"
                          >删除</el-button
                        >
                      </span>
                    </div>
                    <div class="check_block">
                      <el-checkbox
                        label="point"
                        style="margin-right: 10px;"
                        @change="checkClick($event, item, 'point')"
                      >
                        送积分
                      </el-checkbox>
                      <el-input
                        v-model="item.point"
                        size="mini"
                        class="input_box_mini"
                        @focus="inputFocus(index, 'point')"
                        ><template slot="append">分</template></el-input
                      >
                    </div>
                    <div class="check_block">
                      <el-checkbox
                        label="coupon"
                        @change="checkClick($event, item, 'coupon')"
                      >
                        送优惠券
                      </el-checkbox>
                      <el-tag
                        v-for="(tag, idx) in item.sList"
                        :key="idx"
                        style="margin-bottom:5px;margin-left:5px;"
                      >
                        {{ tag.name }}
                        <span v-if="tag.choseNum != 1">
                          <span class="colorRed">×</span>
                          {{ tag.choseNum }} 张</span
                        >
                      </el-tag>
                      <el-button
                        size="mini"
                        @click="selectCoupon(index)"
                        style="margin-left:5px"
                        >选择</el-button
                      >
                    </div>

                    <div style="margin: 10px 0;">
                      <el-radio-group v-model="is_unify_lock[index]">
                        <el-radio label="is_unify">每升减</el-radio>
                        <el-radio label="is_lock">锁油价</el-radio>
                      </el-radio-group>
                    </div>
                    <div
                      class="check_block"
                      v-if="is_unify_lock[index] == 'is_unify'"
                    >
                      <el-checkbox
                        label="is_unify"
                        @change="checkClick($event, item, 'is_unify')"
                      >
                        每升减
                      </el-checkbox>
                      <el-button
                        size="mini"
                        @click="addPerLiter(index, '1')"
                        style="margin-left:5px"
                      >
                        编辑
                      </el-button>
                    </div>
                    <div
                      class="check_block"
                      v-if="is_unify_lock[index] == 'is_lock'"
                    >
                      <el-checkbox
                        label="is_lock"
                        @change="checkClick($event, item, 'is_lock')"
                      >
                        锁油价
                      </el-checkbox>
                      <el-button
                        size="mini"
                        @click="lockOil(index, '1')"
                        style="margin-left:5px"
                      >
                        编辑
                      </el-button>
                    </div>
                    <div class="check_block">
                      <el-checkbox
                        label="first_discount"
                        style="margin-right: 10px;"
                        @change="checkClick($event, item, 'first_discount')"
                      >
                        首次消费
                      </el-checkbox>
                      <el-select
                        v-model="item.first_type"
                        style="margin-right: 10px;"
                        size="mini"
                        @change="handleChangeFirst(index, '1')"
                        class="select_box_mini"
                      >
                        <el-option label="免单" value="0"></el-option>
                        <el-option label="打折" value="1"></el-option>
                      </el-select>
                      <div v-if="item.first_type == '1'">
                        <el-input
                          v-model="item.first_value"
                          size="mini"
                          @focus="inputFocus(index, 'first_discount')"
                          class="input_box_mini"
                          style="width: 160px;"
                          ><template slot="prepend">享</template
                          ><template slot="append">折</template></el-input
                        >
                      </div>
                      <div style="margin-left: 5px;">
                        <el-input
                          v-model="item.first_discount_max"
                          size="mini"
                          style="width: 200px;"
                          @focus="inputFocus(index, 'first_discount')"
                          class="input_box_mini"
                          ><template slot="prepend">最高减免</template
                          ><template slot="append">元</template></el-input
                        >
                      </div>
                    </div>
                    <div class="check_block">
                      <el-checkbox
                        style="margin-right: 10px;"
                        label="good_name"
                        @change="checkClick($event, item, 'good_name')"
                      >
                        赠送实物
                      </el-checkbox>
                      <el-input
                        v-model="item.good_name"
                        placeholder="实物名称"
                        size="mini"
                        style="width: 100px;"
                        @focus="inputFocus(index, 'good_name')"
                      ></el-input>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>
              <el-button
                size="small"
                @click="addGiveItem('1')"
                type="primary"
                style="margin-left:65px"
                >添加档位</el-button
              >
              <span style="margin-left:15px;color:#999"
                >最多可添加十个档位</span
              >
            </el-collapse-item>
            <el-collapse-item title="充值倍数" name="2">
              <div>
                <div
                  class="dialogflex"
                  v-for="(item, index) in setlists"
                  :key="index"
                  style="margin-bottom: 30px"
                >
                  <div class="flex_left">
                    <!-- <div class="flex_title">赠送条件</div> -->
                    <div>
                      <span style="margin-right:30px;"
                        >第{{ index + 1 }}档</span
                      >
                      <div class="line_title">消费满</div>
                      <el-input
                        size="small"
                        class="input_box_short"
                        v-model="item.amount"
                      >
                        <template slot="append">
                          元
                        </template>
                      </el-input>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="margin-right:50px;"></span>
                      <div class="line_title">充值倍数</div>
                      <el-input
                        size="small"
                        class="input_box_short"
                        v-model="item.num"
                      >
                        <template slot="append">
                          倍
                        </template>
                      </el-input>
                    </div>
                  </div>
                  <div class="flex_right">
                    <el-checkbox-group v-model="item.give">
                      <div style="margin-bottom: 10px">
                        <el-radio-group v-model="is_unify_locks[index]">
                          <el-radio label="is_unify">每升减</el-radio>
                          <el-radio label="is_lock">锁油价</el-radio>
                        </el-radio-group>
                        <span style="margin-left:100px">
                          <el-button type="text" @click="delSetItem(index, '2')"
                            >删除</el-button
                          >
                        </span>
                      </div>

                      <el-checkbox
                        label="is_unify"
                        class="check_block"
                        v-if="is_unify_locks[index] == 'is_unify'"
                      >
                        每升减
                        <el-button
                          size="mini"
                          @click="addPerLiter(index, '2')"
                          style="margin-left:5px"
                        >
                          编辑
                        </el-button>
                      </el-checkbox>
                      <el-checkbox
                        label="is_lock"
                        class="check_block"
                        v-if="is_unify_locks[index] == 'is_lock'"
                      >
                        锁油价
                        <el-button
                          size="mini"
                          @click="lockOil(index, '2')"
                          style="margin-left:5px"
                        >
                          编辑
                        </el-button>
                      </el-checkbox>
                      <el-checkbox label="first_discount" class="check_block">
                        首次消费
                        <el-select
                          v-model="item.first_type"
                          size="mini"
                          @change="handleChangeFirst(index, '2')"
                          class="select_box_mini"
                        >
                          <el-option label="免单" value="0"></el-option>
                          <el-option label="打折" value="1"></el-option>
                        </el-select>
                        <span v-if="item.first_type == '1'">
                          享
                          <el-input
                            v-model="item.first_value"
                            size="mini"
                            class="input_box_mini"
                          ></el-input>
                          折
                        </span>
                        <span>
                          最高减免
                          <el-input
                            v-model="item.first_discount_max"
                            size="mini"
                            class="input_box_mini"
                          ></el-input>
                          元
                        </span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
                <el-button
                  size="small"
                  @click="addGiveItem('2')"
                  type="primary"
                  style="margin-left:65px"
                  >添加档位</el-button
                >
                <span style="margin-left:15px;color:#999"
                  >最多可添加十个档位</span
                >
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <el-form-item label="参与对象" v-if="card_type != 3">
          <el-radio-group v-model="joinType">
            <el-radio label="0">全部会员</el-radio>
            <el-radio label="1" v-if="card_type == 1">会员等级</el-radio>
          </el-radio-group>
          <div class="selection_box" v-if="card_type == '1' && joinType == '1'">
            <el-checkbox-group v-model="selectLevel">
              <el-checkbox
                v-for="item in vipLevelList"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="是否长期有效">
          <el-radio-group v-model="is_forever">
            <el-radio label="1">长期有效</el-radio>
            <el-radio label="0">时间期限</el-radio>
          </el-radio-group>
          <div class="selection_box" v-if="is_forever == 0">
            <el-date-picker
              v-model="is_foreverTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
        </el-form-item>

        <el-form-item label="参与对象" v-if="card_type == 3">
          <el-radio-group v-model="team_group">
            <el-radio label="0">全部车队</el-radio>
            <el-radio label="1">部分车队分组</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="车队分组" v-if="card_type == 3 && team_group == 1">
          <el-checkbox-group v-model="team_groupArr">
            <el-checkbox
              v-for="item in groupList"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="规则描述">
          <el-input
            type="textarea"
            v-model="des"
            :rows="3"
            class="input_box_large"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top:20px">
          <el-button @click="goback()" size="small">取消</el-button>
          <el-button type="primary" @click="testSave()" size="small"
            >保存</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <!-- 底部提交 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
    <!-- 每升减 -->
    <el-dialog title="编辑每升减" :visible.sync="dialogCar" width="400px">
      <div>
        <div
          v-for="(lock, index) in dialogChonseMoneyCar"
          :key="index"
          class="dialogCar"
        >
          <div class="dialogCarLeft">{{ lock.name }}:</div>
          <div class="dialogCarRight">
            <el-button v-if="!lock.itemArr.length" type="text">
              该选项下暂无关联油品
            </el-button>
            <el-form class="demo-form-inline" v-else>
              <el-form-item
                :label="son.name"
                v-for="(son, index) in lock.itemArr"
                :key="index"
              >
                减
                <el-input
                  v-model="son.money"
                  placeholder="0.00"
                  size="small"
                  style="width: 60px;"
                ></el-input>
                元
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCar = false">取 消</el-button>
        <el-button type="primary" @click="dialogCar = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 锁油价 -->
    <el-dialog title="编辑锁油价" :visible.sync="dialogLock" width="400px">
      <div>
        <div
          v-for="(lock, index) in dialogChonseLockCar"
          :key="index"
          class="dialogCar"
        >
          <div class="dialogCarLeft">{{ lock.name }}:</div>
          <div class="dialogCarRight">
            <el-button v-if="!lock.itemArr.length" type="text">
              该选项下暂无关联油品
            </el-button>
            <el-form class="demo-form-inline" v-else>
              <el-form-item
                :label="son.name"
                v-for="(son, index) in lock.itemArr"
                :key="index"
              >
                <el-input
                  v-model="son.money"
                  placeholder="0.00"
                  size="small"
                  style="width: 60px;"
                ></el-input>
                元
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLock = false">取 消</el-button>
        <el-button type="primary" @click="dialogLock = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { cardList, detailCard, groupList } from "@/api/motorcade";
import {
  detailLevel,
  detailRefule,
  goodsList,
  listRefule,
  rechargeAdd,
  rechargeDetail,
  rechargeEdit,
  vipList,
  voucherSet,
} from "@/api/vip";

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    newSelectCommodityNum,
  },
  data() {
    return {
      activeName: "1",
      is_forever: "1",
      is_foreverTime: [],
      formData: {
        //充值优惠
        type: "0",
      },
      discountList: [], //充值优惠列表
      typeList: [
        //优惠类别
        { id: "1", name: "积分" },
        { id: "2", name: "余额" },
        { id: "3", name: "优惠券" },
      ],
      showSelecter: false, //优惠券选择器
      selected: [], //选择的优惠券
      sList: [], //已选择的优惠券列表
      giveList: [], //赠送内容列表
      amount: "",
      card_type: 0, //业务类型
      setlist: [
        {
          amount: "",
          balance: "",
          point: "",
          give: [],
          sList: [],
          first_type: "0",
          first_discount_max: "",
          first_value: "",
          good_name: "",
        },
      ], //内容列表
      setlists: [
        {
          amount: "",
          num: "",
          balance: "0",
          point: "0",
          give: [],
          sList: [],
          first_type: "0",
          first_discount_max: "",
          first_value: "",
          good_name: "",
        },
      ],
      sIndex: 0, //选择优惠券的档位index
      vipLevelList: [], //会员等级列表
      selectLevel: [], //选择的会员等级
      oilsCardList: [], //加油卡列表
      selectOilsCard: [], //加油卡列表
      cardListCard: [], //车队卡列表
      selectCardList: [], //车队卡列表
      joinType: "0", //参与对象  0:全部 1:部分
      des: "", //自定义规则输入框
      is_add: true, //是否是新增
      groupList: [], //车队分组
      team_group: "0", //车队分组是否开启： 1全部
      team_groupArr: [],
      team_group_ids: "",
      allchonseMoneyCar: [[]], //新增每升减弹窗展示数据
      allchonseLockCar: [[]], //新增每升减弹窗展示数据
      allchonseMoneyCars: [[]], //新增每升减弹窗展示数据
      allchonseLockCars: [[]], //新增每升减弹窗展示数据
      dialogCar: false,
      dialogLock: false,
      dialogChonseMoneyCar: [], //弹窗数据 每升减
      dialogChonseLockCar: [], //弹窗数据
      levelObjArr: [],
      is_unify_lock: [""],
      is_unify_locks: [""],
    };
  },
  watch: {
    card_type: function() {
      if (!this.$route.query.eid) {
        this.selectLevel = [];
      }
    },
  },
  mounted() {
    this.getData();
    this.getGroupList();
    this.getOil();
  },
  methods: {
    // 获取全部油品
    getOil() {
      goodsList({ app_id: this.app_id, token: this.token }).then((res) => {
        let oilDatas = [];
        if (res.code == 200) {
          oilDatas = res.data;
          oilDatas.forEach((item) => {
            // console.log
            let inlineObj = {
              good_id: item.id,
              name: item.name,
              money: "",
            };
            this.levelObjArr.push(inlineObj);
          });
          console.log("油品全部数据", oilDatas);
        }
      });
    },
    // 新增每升减 锁油价
    addPerLiter(index, key) {
      if (key == "1") {
        console.log("this.allchonseMoneyCar", this.allchonseMoneyCar);
        this.allchonseMoneyCar[index] = this.getCarDetail(
          this.allchonseMoneyCar[index]
        );
        this.dialogChonseMoneyCar = this.allchonseMoneyCar[index];
      } else {
        console.log("this.allchonseMoneyCars", this.allchonseMoneyCars);
        this.allchonseMoneyCars[index] = this.getCarDetail(
          this.allchonseMoneyCars[index]
        );
        this.dialogChonseMoneyCar = this.allchonseMoneyCars[index];
      }
      setTimeout(() => {
        // if (this.dialogChonseMoneyCar.length) {
        this.dialogCar = true;
        // }
      }, 300);
    },
    // 新增锁油价

    lockOil(index, key) {
      if (key == "1") {
        // 获取动态数据
        this.allchonseLockCar[index] = this.getCarDetail(
          this.allchonseLockCar[index]
        );
        this.dialogChonseLockCar = this.allchonseLockCar[index];
      } else {
        // 获取动态数据
        this.allchonseLockCars[index] = this.getCarDetail(
          this.allchonseLockCars[index]
        );
        this.dialogChonseLockCar = this.allchonseLockCars[index];
      }

      setTimeout(() => {
        // if (this.dialogChonseLockCar.length) {
        this.dialogLock = true;
        // }
      }, 300);
    },
    // 获取数据 dataArr=>上一次的数据
    getCarDetail(dataArr) {
      let oilArr = JSON.parse(JSON.stringify(this.levelObjArr));
      var allchose = dataArr;
      var newShell = [];
      switch (this.card_type) {
        case 0:
          // 会员卡
          if (!this.selectLevel.length) {
            this.$message.warning("请至少选择某个卡项！！");
            return [];
          } else {
            this.selectLevel.forEach((item) => {
              //  判断是否已经存在
              let is_status = false;
              allchose.forEach((son) => {
                if (item == son.id) {
                  is_status = true;
                  newShell.push(son);
                  console.log("相同", newShell);
                }
              });
              if (!is_status) {
                console.log("bu相同", newShell);
                let data = {
                  token: this.token,
                  app_id: this.app_id,
                  id: item,
                };
                let dataShelll = {};
                detailLevel(data).then((res) => {
                  dataShelll = res.data;
                  var obj = {
                    id: dataShelll.id,
                    name: dataShelll.name,
                    // itemArr: []
                    itemArr: JSON.parse(JSON.stringify(this.levelObjArr)),
                  };
                  newShell.push(obj);
                });
              }
            });
            return newShell;
          }
        case 1:
          // 加油卡
          if (!this.selectOilsCard.length) {
            this.$message.warning("请至少选择某个卡项！！");
            return [];
          } else {
            this.selectOilsCard.forEach((item) => {
              //  判断是否已经存在
              let is_status = false;
              allchose.forEach((son) => {
                if (item == son.id) {
                  is_status = true;
                  newShell.push(son);
                  console.log("相同", newShell);
                }
              });
              if (!is_status) {
                console.log("bu相同", newShell);
                let data = {
                  token: this.token,
                  app_id: this.app_id,
                  id: item,
                };
                let dataShelll = {};
                detailRefule(data).then((res) => {
                  dataShelll = res.data;
                  var obj = {
                    id: dataShelll.id,
                    name: dataShelll.name,
                    itemArr: [],
                  };
                  if (dataShelll.goods.length) {
                    let arrs = dataShelll.goods;
                    arrs.forEach((item) => {
                      // console.log
                      let inlineObj = {
                        good_id: item.id,
                        name: item.name,
                        money: "",
                      };
                      obj.itemArr.push(inlineObj);
                    });
                  }

                  newShell.push(obj);
                  // console.log("每升减数据", allchose, allchose.length);
                });
              }
            });
            return newShell;
          }
        case 3:
          // 車隊卡
          if (!this.selectCardList.length) {
            this.$message.warning("请至少选择某个卡项！！");
            return [];
          } else {
            this.selectCardList.forEach((item) => {
              //  判断是否已经存在
              let is_status = false;
              allchose.forEach((son) => {
                if (item == son.id) {
                  is_status = true;
                  newShell.push(son);
                  console.log("相同", newShell);
                }
              });
              if (!is_status) {
                console.log("bu相同", newShell);
                let data = {
                  token: this.token,
                  app_id: this.app_id,
                  id: item,
                };
                let dataShelll = {};
                detailCard(data).then((res) => {
                  dataShelll = res.data;
                  var obj = {
                    id: dataShelll.id,
                    name: dataShelll.name,
                    itemArr: [],
                  };
                  if (dataShelll.goods.length) {
                    let arrs = dataShelll.goods;
                    arrs.forEach((item) => {
                      // console.log
                      let inlineObj = {
                        good_id: item.id,
                        name: item.name,
                        money: "",
                      };
                      obj.itemArr.push(inlineObj);
                    });
                  }

                  newShell.push(obj);
                  // console.log("每升减数据", allchose, allchose.length);
                });
              }
            });
            return newShell;
          }
          break;
      }
    },
    //验证是否相同 (卡项与每升减)
    getCarComment(arrShell) {
      var is_status = true;
      switch (this.card_type) {
        case 0:
          // 会员卡
          var selectArr = this.selectLevel.map((item) => {
            return item * 1;
          });
          var repeactArr = new Set(selectArr.concat(arrShell));
          if (repeactArr.size != selectArr.length) {
            is_status = false;
          }
          break;
        case 1:
          // 加油卡
          var selectArr = this.selectOilsCard.map((item) => {
            return item * 1;
          });
          var repeactArr = new Set(selectArr.concat(arrShell));
          if (repeactArr.size != selectArr.length) {
            is_status = false;
          }
          break;
        case 3:
          // 车队卡
          var selectArr = this.selectCardList.map((item) => {
            return item * 1;
          });
          var repeactArr = new Set(selectArr.concat(arrShell));
          if (repeactArr.size != selectArr.length) {
            is_status = false;
          }
          break;
      }
      return is_status;
    },
    getGroupList() {
      groupList({ token: this.token, app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          this.groupList = res.result;
        }
        console.log("groupList", res);
      });
    },
    getData() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      this.$nextTick(function() {
        // 获取会员卡等级列表
        vipList(data).then((res) => {
          if (res.code == 200) {
            this.vipLevelList = [];
            res.data.forEach((item) => {
              var i = {
                id: String(item.id),
                name: item.name,
              };
              this.vipLevelList.push(i);
            });

            console.log("获取会员卡等级列表", this.vipLevelList);
            this.get_Detail();
          }
        });

        // 加油卡列表
        listRefule(data).then((res) => {
          if (res.code == 200) {
            this.oilsCardList = [];
            res.result.forEach((item) => {
              var i = {
                id: String(item.id),
                name: item.name,
              };
              this.oilsCardList.push(i);
            });
          }
        });
        // 车队卡列表
        cardList(data).then((res) => {
          console.log(res);
          this.cardListCard = res.result;
          this.total = res.total_num;
        });
      });
    },
    get_Detail() {
      if (this.$route.query.eid !== undefined) {
        //编辑
        this.is_add = false;
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.$route.query.eid,
        };
        rechargeDetail(data).then((res) => {
          if (res.code == 200) {
            console.log("详情", res.data);
            // 每升减 所有件
            this.allchonseMoneyCar = [];
            this.allchonseLockCar = [];
            this.allchonseMoneyCars = [];
            this.allchonseLockCars = [];
            var edata = Object.assign({}, res.data);
            this.is_forever = String(edata.is_forever);
            if (edata.is_forever == 0) {
              this.is_foreverTime[0] = edata.start_time;
              this.is_foreverTime[1] = edata.end_time;
            }
            console.log(this.is_foreverTime);
            this.card_type = edata.card_type;
            this.joinType = `${res.data.take_type}`;
            if (edata.card_type == 0) {
              this.selectLevel =
                edata.card_ids == "" ? [] : edata.card_ids.split(",");
            } else if (edata.card_type == 1) {
              this.selectLevel =
                edata.level_ids == "" ? [] : edata.level_ids.split(",");
              this.selectOilsCard =
                edata.card_ids == "" ? [] : edata.card_ids.split(",");
              console.log("www", this.selectOilsCard);
              console.log("rrrr", this.selectLevel);
            } else if (edata.card_type == 3) {
              this.selectCardList =
                edata.card_ids == "" ? [] : edata.card_ids.split(",");
              this.selectCardList = this.selectCardList.map((item) => {
                return item * 1;
              });
              this.team_group = String(edata.team_group);
              if (edata.team_group == 1) {
                this.team_groupArr = edata.team_group_ids.split(",");
              }
              this.team_groupArr = this.team_groupArr.map((item) => {
                return item * 1;
              });
            }
            this.des = edata.des;
            this.setlist = [];
            this.setlists = [];
            if (edata.rule) {
              edata.rule.forEach((item, edata_index) => {
                var i = {
                  amount: item.charge_money,
                  balance: "",
                  point: "",
                  good_name: "",
                  give: [],
                  sList: [],
                  first_type: "0",
                  first_value: "",
                  first_discount_max: "",
                };
                if (item.money_status == "1") {
                  i.give.push("balance");
                  i.balance = item.money;
                }
                if (item.point_status == "1") {
                  i.give.push("point");
                  i.point = item.point;
                }
                if (item.good_status == "1") {
                  i.give.push("good_name");

                  i.good_name = item.good_name;
                }
                if (item.coupon_status == "1") {
                  i.give.push("coupon");
                  // 新增
                  let couponIds = item.coupon_ids.split(",");
                  i.sList = item.coupon_data.map((x) => {
                    let dNum = "0";
                    for (let d = 0; d < couponIds.length; d++) {
                      if (x.id == couponIds[d]) {
                        dNum++;
                      }
                    }
                    return {
                      choseNum: dNum,
                      id: x.id,
                      name: x.title,
                      url:
                        "https://yckj-common.oss-cn-beijing.aliyuncs.com/1576482532.jpg",
                    };
                  });
                }
                // 新增每升减
                if (item.is_unify == "1") {
                  this.is_unify_lock[edata_index] = "is_unify"; //又新增二选一
                  i.give.push("is_unify");
                  i.is_unify = item.is_unify;
                  this.allchonseMoneyCar.push(item.liter_good_money);
                } else {
                  this.allchonseMoneyCar.push([]);
                }
                // 新增锁油价
                if (item.is_lock == "1") {
                  this.is_unify_lock[edata_index] = "is_lock"; //又新增二选一
                  i.give.push("is_lock");
                  i.is_lock = item.is_lock;
                  this.allchonseLockCar.push(item.lock_good_money);
                } else {
                  this.allchonseLockCar.push([]);
                }
                // 又新增（锁油价和每升减二选一）

                // 新增 充值首次消费免单/打折
                if (item.first_discount == "1") {
                  i.give.push("first_discount");
                  i.first_discount_max = item.first_discount_max;
                  if (item.first_pay_discount == "100") {
                    i.first_type = "0";
                  } else {
                    i.first_type = "1";
                    i.first_value =
                      (100 - Number(item.first_pay_discount)) / 10;
                  }
                }

                this.setlist.push(i);
                console.log("编辑整合数据！！", this.setlist);
              });
            }

            console.log("shuju", edata);
            if (edata.multiple_rule) {
              edata.multiple_rule.forEach((item, edata_index) => {
                var i = {
                  amount: item.grade_money,
                  num: item.multiple_num,
                  balance: "0",
                  point: "0",
                  good_name: "",
                  give: [],
                  sList: [],
                  first_type: "0",
                  first_value: "",
                  first_discount_max: "",
                  is_multiple: "1",
                };
                // 新增每升减
                if (item.is_unify == "1") {
                  this.is_unify_locks[edata_index] = "is_unify"; //又新增二选一
                  i.give.push("is_unify");
                  i.is_unify = item.is_unify;
                  this.allchonseMoneyCars.push(item.liter_good_money);
                } else {
                  this.allchonseMoneyCars.push([]);
                }
                console.log(this.allchonseMoneyCars);
                // 新增锁油价
                if (item.is_lock == "1") {
                  this.is_unify_locks[edata_index] = "is_lock"; //又新增二选一
                  i.give.push("is_lock");
                  i.is_lock = item.is_lock;
                  this.allchonseLockCars.push(item.lock_good_money);
                } else {
                  this.allchonseLockCars.push([]);
                }
                // 又新增（锁油价和每升减二选一）

                // 新增 充值首次消费免单/打折
                if (item.first_discount == "1") {
                  i.give.push("first_discount");
                  i.first_discount_max = item.first_discount_max;
                  if (item.first_pay_discount == "100") {
                    i.first_type = "0";
                  } else {
                    i.first_type = "1";
                    i.first_value =
                      (100 - Number(item.first_pay_discount)) / 10;
                  }
                }

                this.setlists.push(i);
                console.log("编辑整合数据！！", this.setlist);
              });
            }
          }
        });
      }
    },
    //选择优惠券
    getCommod(data) {
      this.setlist[this.sIndex].sList = data;
      console.log("选择的优惠券！！", this.setlist);

      this.showSelecter = false;
    },
    //删除选择的优惠券
    delTagItem(i, x) {
      console.log(i, x);
      this.setlist[i].sList.splice(x, 1);
      // this.sList.splice(i,1);
    },
    //选择赠送内容防止重复
    resetOptions() {
      console.log(this.giveList);
      this.typeList.forEach((item) => {
        item.disable = false;
      });
      this.giveList.forEach((item) => {
        this.typeList.forEach((options) => {
          if (options.id == item.type_id) {
            options.disable = true;
          }
        });
      });
    },
    //添加赠送内容
    addGiveItem(key) {
      if (key == "1") {
        if (this.setlist.length < 10) {
          this.setlist.push({
            amount: "",
            balance: "",
            point: "",
            give: [], //赠送类型 balance:余额 point:积分 coupon:优惠券is_unify新增每升减 is_lock锁油价
            sList: [],
          });
          // 新增锁油价， 每升减
          this.allchonseMoneyCar.push([]); //新增每升减弹窗展示数据
          this.allchonseLockCar.push([]);
          this.is_unify_lock.push("");
        }
      } else {
        if (this.setlists.length < 10) {
          this.setlists.push({
            amount: "",
            num: "",
            balance: "0",
            point: "0",
            give: [], //赠送类型 balance:余额 point:积分 coupon:优惠券is_unify新增每升减 is_lock锁油价
            sList: [],
          });
          // 新增锁油价， 每升减
          this.allchonseMoneyCars.push([]); //新增每升减弹窗展示数据
          this.allchonseLockCars.push([]);
          this.is_unify_locks.push("");
        }
      }
    },
    //删除赠送内容
    delGiveItem(i) {
      this.giveList.splice(i, 1);
      this.resetOptions();
    },
    // 测试保存
    testSave() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        card_type: this.card_type,
        des: this.des,
        team_group: this.team_group,
        team_group_ids: this.team_group_ids,
        is_forever: this.is_forever,
      };
      if (data.is_forever == 0) {
        if (this.is_foreverTime.length < 2) {
          return this.$message("请选择结束时间和开始时间");
        }
        data.start_time = this.is_foreverTime[0];
        data.end_time = this.is_foreverTime[1];
      }
      //车队卡 cardListCard
      if (this.card_type == 3) {
        if (this.selectCardList.length == 0) {
          this.$message.warning("请选择卡项！！");
          return false;
        }
        data.card_ids = this.selectCardList.join(",");
        if (this.team_group == 1 && this.team_groupArr.length == 0) {
          this.$message.warning("请选择部分分组！！");
          return false;
        }
        data.team_group_ids =
          this.team_group == 1 ? this.team_groupArr.join(",") : "";
      } else if (this.card_type == 0) {
        if (this.selectLevel.length == 0) {
          this.$message.warning("请选择卡项！！");
          return false;
        }
        data.card_ids = this.selectLevel.join(",");
      } else {
        if (this.selectOilsCard.length == 0) {
          this.$message.warning("请选择卡项！！");
          return false;
        }
        data.card_ids = this.selectOilsCard.join(",");
      }
      data.take_type = this.joinType;
      if (this.joinType == 1 && this.card_type == 1) {
        if (this.selectLevel.length > 0) {
          data.level_ids = this.selectLevel.join(",");
        } else {
          data.level_ids = "";
        }
      } else {
        data.level_ids = "";
      }
      var list = [];
      var lists = [];
      console.log("8888", this.setlist);
      this.setlist.forEach((item, c_index) => {
        var i = {};
        i.charge_money = item.amount;
        if (item.give.some((x) => x == "balance")) {
          i.money_status = "1";
          i.money = item.balance;
        } else {
          i.money_status = "0";
          i.money = "0";
        }
        if (item.give.some((x) => x == "point")) {
          i.point_status = "1";
          i.point = item.point;
        } else {
          i.point_status = "0";
          i.point = "0";
        }
        if (item.give.some((x) => x == "good_name")) {
          i.good_status = "1";
          i.good_name = item.good_name;
        } else {
          i.good_status = "0";
          i.good_name = "";
        }
        if (item.give.some((x) => x == "coupon")) {
          i.coupon_status = "1";
          let arrCountId = [];
          item.sList.forEach((sonItem) => {
            if (sonItem.choseNum) {
              console.log("选择数", sonItem.choseNum);
              for (var n = 0; n < Number(sonItem.choseNum); n++) {
                arrCountId.push(sonItem.id);
              }
            }
          });
          i.coupon_ids = arrCountId.join(",");
          // i.coupon_ids = item.sList.map(x => x.id).join(",");
        } else {
          i.coupon_status = "0";
          i.coupon_ids = "";
        }

        // 新增锁油价和每升减二选一

        if (this.is_unify_lock[c_index] == "is_unify") {
          //
          i.lock_good_money = [];
          i.is_lock = "0";
          // 新增每升减 锁油价
          if (item.give.some((x) => x == "is_unify")) {
            // 判断选中的油卡规则是否存在是在调取添加接口时，防止更换卡项时已经存在的每升减和锁油价不匹配
            if (this.allchonseMoneyCar[c_index].length) {
              let arrShell = [];
              this.allchonseMoneyCar[c_index].forEach((item) => {
                arrShell.push(item.id * 1);
              });
              let newStatus = this.getCarComment(arrShell);
              i.liter_good_money = newStatus
                ? this.allchonseMoneyCar[c_index]
                : [];
              // 簡單粗暴直接判断相等吗不等不赋值
            } else {
              this.$message.warning("请编辑每升减选项！！");
              return;
            }
            i.is_unify = "1";
          } else {
            i.liter_good_money = [];
            i.is_unify = "0";
          }
        } else {
          // 怕用户两个都勾选的情况
          i.liter_good_money = [];
          i.is_unify = "0";
          //
          if (item.give.some((x) => x == "is_lock")) {
            // i.is_lock = this.allchonseLockCar.length ? this.allchonseLockCar : [];
            // 判断选中的油卡规则是否存在是在调取添加接口时，防止更换卡项时已经存在的每升减和锁油价不匹配
            if (this.allchonseLockCar[c_index].length) {
              let arrShell = [];
              this.allchonseLockCar[c_index].forEach((item) => {
                arrShell.push(item.id * 1);
              });
              let newStatus = this.getCarComment(arrShell);
              i.lock_good_money = newStatus
                ? this.allchonseLockCar[c_index]
                : [];
              // 簡單粗暴直接判断相等吗不等不赋值
            } else {
              this.$message.warning("请编辑每升减选项！！");
              return;
            }
            i.is_lock = "1";
          } else {
            i.lock_good_money = [];
            i.is_lock = "0";
          }
        }
        if (item.give.some((x) => x == "first_discount")) {
          i.first_discount = "1";
          // i.first_pay_discount = item.balance;
          i.first_discount_max = item.first_discount_max;
          if (item.first_type == "0") {
            i.first_pay_discount = "100";
          } else {
            if (!item.first_value) {
              return this.$message("请输入首次消费折扣");
            } else {
              i.first_pay_discount = 100 - Number(item.first_value * 10);
            }
          }
        } else {
          i.first_discount = "0";
          i.first_pay_discount = "0";
          i.first_discount_max = "";
        }
        list.push(i);
      });
      this.setlists.forEach((item, c_index) => {
        var i = {};
        i.grade_money = item.amount;
        i.is_multiple = "1";
        i.multiple_num = item.num;
        i.money_status = "0";
        i.money = "0";
        i.point_status = "0";
        i.point = "0";
        i.good_status = "0";
        i.good_name = "";
        i.coupon_status = "0";
        i.coupon_ids = "";
        // 新增锁油价和每升减二选一

        if (this.is_unify_locks[c_index] == "is_unify") {
          //
          i.lock_good_money = [];
          i.is_lock = "0";
          // 新增每升减 锁油价
          if (item.give.some((x) => x == "is_unify")) {
            // 判断选中的油卡规则是否存在是在调取添加接口时，防止更换卡项时已经存在的每升减和锁油价不匹配
            if (this.allchonseMoneyCars[c_index].length) {
              let arrShell = [];
              this.allchonseMoneyCars[c_index].forEach((item) => {
                arrShell.push(item.id * 1);
              });
              let newStatus = this.getCarComment(arrShell);
              i.liter_good_money = newStatus
                ? this.allchonseMoneyCars[c_index]
                : [];
              // 簡單粗暴直接判断相等吗不等不赋值
            } else {
              this.$message.warning("请编辑每升减选项！！");
              return;
            }
            i.is_unify = "1";
          } else {
            i.liter_good_money = [];
            i.is_unify = "0";
          }
        } else {
          // 怕用户两个都勾选的情况
          i.liter_good_money = [];
          i.is_unify = "0";
          //
          if (item.give.some((x) => x == "is_lock")) {
            // i.is_lock = this.allchonseLockCar.length ? this.allchonseLockCar : [];
            // 判断选中的油卡规则是否存在是在调取添加接口时，防止更换卡项时已经存在的每升减和锁油价不匹配
            if (this.allchonseLockCars[c_index].length) {
              let arrShell = [];
              this.allchonseLockCars[c_index].forEach((item) => {
                arrShell.push(item.id * 1);
              });
              let newStatus = this.getCarComment(arrShell);
              i.lock_good_money = newStatus
                ? this.allchonseLockCars[c_index]
                : [];
              // 簡單粗暴直接判断相等吗不等不赋值
            } else {
              this.$message.warning("请编辑每升减选项！！");
              return;
            }
            i.is_lock = "1";
          } else {
            i.lock_good_money = [];
            i.is_lock = "0";
          }
        }
        if (item.give.some((x) => x == "first_discount")) {
          i.first_discount = "1";
          // i.first_pay_discount = item.balance;
          i.first_discount_max = item.first_discount_max || "";
          if (item.first_type == "0") {
            i.first_pay_discount = "100";
          } else {
            if (!item.first_value) {
              return this.$message("请输入首次消费折扣");
            } else {
              i.first_pay_discount = 100 - Number(item.first_value * 10);
            }
          }
        } else {
          i.first_discount = "0";
          i.first_pay_discount = "0";
          i.first_discount_max = "";
        }
        lists.push(i);
      });
      data.rule = list;
      data.multiple_rule = lists;
      console.log("测试", data);
      // return false;
      if (this.is_add) {
        rechargeAdd(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.goback();
          } else {
            this.$message(res.msg);
          }
        });
      } else {
        data.id = this.$route.query.eid;
        rechargeEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.goback();
          } else {
            this.$message(res.msg);
          }
        });
      }
    },
    //保存
    save() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        config: [
          {
            id: 0,
          },
        ],
      };
      this.giveList.forEach((n) => {
        //n.type_id: 1.积分2.余额3.优惠券
        if (n.type_id == "1") {
          data.config[0].point = n.value;
        }
        if (n.type_id == "2") {
          data.config[0].balance = n.value;
        }
        if (n.type_id == "3") {
          var coupons = "";
          this.sList.forEach((item) => {
            coupons += item.id + ",";
          });
          data.config[0].coupons = coupons.substring(0, coupons.length - 1);
        }
      });
      data.level_id = this.selectLevel.join(",");
      console.log(data);
      // 传入已有优惠
      this.discountList.forEach((item) => {
        var rechange = {
          id: item.id,
          amount: item.amount,
          point: item.point,
          balance: item.balance,
        };
        var c = "";
        if (item.coupons.length) {
          item.coupons.forEach((n) => {
            c += n.id + ",";
          });
          rechange.coupons = c.substring(0, c.length - 1);
        }
        data.config.push(rechange);
      });
      return false;
      voucherSet(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功",
          });
          // this.showAdd = false;
          this.goback();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    goback() {
      this.$router.go(-1);
    },
    // 档位删除
    delSetItem(i, key) {
      if (key == "1") {
        this.setlist.splice(i, 1);
        // 新增锁油价， 每升减
        console.log("原始数据", this.allchonseLockCar, i);
        this.allchonseMoneyCar.splice(i, 1); //新增每升减弹窗展示数据
        console.log("end数据", this.allchonseLockCar);
        this.allchonseLockCar.splice(i, 1);
        // radio 二選一(锁油价， 每升减))
        this.is_unify_lock.splice(i, 1);
      } else {
        this.setlists.splice(i, 1);
        // 新增锁油价， 每升减
        console.log("原始数据", this.allchonseLockCars, i);
        this.allchonseMoneyCars.splice(i, 1); //新增每升减弹窗展示数据
        console.log("end数据", this.allchonseLockCar);
        this.allchonseLockCars.splice(i, 1);
        // radio 二選一(锁油价， 每升减))
        this.is_unify_locks.splice(i, 1);
      }
    },
    // 打开选择优惠券弹窗
    selectCoupon(i) {
      console.log(this.setlist[i]);
      this.sIndex = i;
      this.sList = this.setlist[i].sList;
      this.showSelecter = true;
    },
    checkClick(e, item, key) {
      if (e) {
        let index = item.give.findIndex((x) => x == key);
        if (key == "first_discount") {
          this.$confirm("是否选择此项？", "提示", {
            type: "warning",
          })
            .then(() => {})
            .catch(() => {
              item.give.splice(index, 1);
            });
        } else {
          if (item.give.length > 2) {
            this.$confirm("是否选择此项？", "提示", {
              type: "warning",
            })
              .then(() => {})
              .catch(() => {
                item.give.splice(index, 1);
              });
          }
        }
      }
    },
    // 输入框onfocus事件
    inputFocus(index, value) {
      if (!this.setlist[index].give.find((x) => x == value)) {
        this.setlist[index].give.push(value);
      }
    },
    handleChangeFirst(index, key) {
      // 选择本次消费免单/打折
      if (key == "1") {
        if (!this.setlist[index].give.some((x) => x == "first_discount")) {
          this.setlist[index].give.push("first_discount");
        }
      } else {
        if (!this.setlists[index].give.some((x) => x == "first_discount")) {
          this.setlists[index].give.push("first_discount");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.colorRed {
  color: red;
  padding: 0 6px;
}
.content {
  padding: 0 20px 60px 20px;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  background: #f2f2f6;
  font-size: 14px;
  overflow: scroll;
  position: relative;
  .box {
    background: #fff;
    margin-top: 20px;
    padding: 10px 0px;
    .title {
      font-weight: 550;
      padding: 10px 0px 10px 20px;
    }
    // 样式
    .textAlign {
      text-align: right;
    }
    .color {
      margin: 0px 5px;
      color: #999;
      font-size: 12px;
    }
    .inputMargin {
      margin: 0 6px;
    }
    .inputWidth {
      height: 30px;
      width: 130px;
    }
    .selection_box {
      margin-top: 10px;
    }
  }
  // 表格
  .table {
    max-width: 600px;
    padding: 10px 5px;
    background: #f2f2f6;
    height: 100%;
    > div {
      padding: 10px;
    }
    .name {
      font-weight: 550;
      padding: none;
    }
    .table-left {
      width: 200px;

      border-right: 1px solid #fff;
    }
    .table-right {
      flex: 1;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .fixedWidth {
    width: 500px;
    .line {
      text-align: center;
    }
  }
  // 底部
  .bottom {
    position: fixed;
    bottom: 0;
    border-top: 1px solid #f2f2f6;
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }
  // 表单
  .rule_box {
    margin-left: 110px;
    margin-bottom: 15px;
  }
  .dialogflex {
    display: flex;
    padding: 5px;
    .flex_title {
      margin-bottom: 25px;
      font-weight: bold;
    }
    .item_line {
      margin-bottom: 10px;
      display: flex;
      .type {
        margin-right: 15px;
      }
      .value {
        flex: 1;
      }
      .close {
        margin: 0 10px;
      }
      .input_box_small {
        width: 140px;
      }
    }
    .line_title {
      height: 32px;
      line-height: 32px;
      display: inline-block;
    }
    .input_box_short {
      width: 140px;
      margin-left: 15px;
      vertical-align: top;
    }
    .input_box_mini {
      width: 130px;
    }
    .select_box_mini {
      width: 80px;
    }
    .check_block {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .flex_left {
      margin-right: 20px;
    }
    .flex_right {
      flex: 1;
      border-left: 1px solid #ccc;
      padding-left: 20px;
    }
    .ml10 {
      margin-left: 10px;
    }
  }
  .input_box_large {
    width: 480px;
  }
  // 新增 每升减
  .dialogCar {
    display: flex;
    .dialogCarLeft {
      min-width: 60px;
      text-align: right;
      margin-right: 20px;
      padding-top: 10px;
    }
    .dialogCarRight {
      flex: 1;
      width: 60px;
    }
  }
}
</style>
